module.exports = "<!-- TODO: add a tooltip containing the display text here -->\n<span class=\"icons\">\n<span class=\"icon medium\" [ngClass]=\"codeItem | icon\"></span>\n<prg-code-item-icons *ngFor=\"let child of codeItem?.codeItems\" [codeItem]=\"child\"></prg-code-item-icons>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/code-item-icons/code-item-icons.component.html
// module id = 1555
// module chunks = 2